"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Market = void 0;
var typeorm_1 = require("typeorm");
var BilateralTrade_entity_1 = require("./BilateralTrade.entity");
var OpenTrade_entity_1 = require("./OpenTrade.entity");
var Market = /** @class */ (function () {
    function Market() {
    }
    __decorate([
        (0, typeorm_1.PrimaryGeneratedColumn)(),
        __metadata("design:type", Number)
    ], Market.prototype, "marketID", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], Market.prototype, "name", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], Market.prototype, "label", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], Market.prototype, "volumeUnits", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], Market.prototype, "priceUnits", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], Market.prototype, "type", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], Market.prototype, "typeLabel", void 0);
    __decorate([
        (0, typeorm_1.OneToMany)(function () { return BilateralTrade_entity_1.BilateralTrade; }, function (bilateralTrade) { return bilateralTrade.market; }),
        __metadata("design:type", Array)
    ], Market.prototype, "bilateralTradeMarketID", void 0);
    __decorate([
        (0, typeorm_1.OneToMany)(function () { return OpenTrade_entity_1.OpenTrade; }, function (openTrade) { return openTrade.market; }),
        __metadata("design:type", Array)
    ], Market.prototype, "openTradeMarketID", void 0);
    Market = __decorate([
        (0, typeorm_1.Entity)({ name: 'markets' })
    ], Market);
    return Market;
}());
exports.Market = Market;
//# sourceMappingURL=Market.entity.js.map